module.exports = __webpack_public_path__ + "img/path.becb50a9.png";